// extracted by mini-css-extract-plugin
export default {"avatar":"ProfileLinks_avatar__DPJxs","avatarIn":"ProfileLinks_avatarIn__vYYXR"};